import moment from 'moment';

import {
    SET_USER_ID_VK,
    SET_ACTIVE_MODAL_VK,
    SET_ACTIVE_PANEL_VK,
    CHANGE_FIELD_MODAL_VK,
    RESPONSE_GET_USER_VK,
    RESPONSE_ADD_USER_PHONE_VK,
    ADD_USER_VK
} from './actions';

const initialState = {
    fastWriteVK: {
        phone: null,
        date: moment()
    },
    hasRequestedPhone: false,
    userInfo: {
        firstName: null,
        lastName: null,
        birthday: null,
        phone: null
    },
    userID: null,
    activeModal: null,
    activePanel: 'schedulePanel',
    ticketData: null
};

export default function reduser(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_USER_ID_VK:
            return {
                ...state,
                userID: payload
            };
        case SET_ACTIVE_MODAL_VK:
            return {
                ...state,
                activeModal: payload
            };
        case SET_ACTIVE_PANEL_VK:
            return {
                ...state,
                activePanel: payload
            };
        case CHANGE_FIELD_MODAL_VK:
            return {
                ...state,
                fastWriteVK: {
                    ...state.fastWriteVK,
                    [payload.property]: payload.value
                }
            };
        case RESPONSE_GET_USER_VK: {
            if (payload) {
                return {
                    ...state,
                    hasRequestedPhone: true,
                    fastWriteVK: {
                        ...state.fastWriteVK,
                        phone: payload.phone,
                    },
                    userInfo: {
                        ...state.userInfo,
                        firstName: payload.first_name,
                        lastName: payload.last_name,
                        birthday: payload.birthday,
                        phone: payload.phone
                    }
                };
            }
            return {
                ...state,
                hasRequestedPhone: true
            };
        }
        case ADD_USER_VK:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    firstName: payload.first_name,
                    lastName: payload.last_name,
                    birthday: payload.bdate ? payload.bdate : null
                }
            };
        case RESPONSE_ADD_USER_PHONE_VK: {
            if (payload) {
                return {
                    ...state,
                    hasRequestedPhone: true,
                    fastWriteVK: {
                        ...state.fastWriteVK,
                        phone: payload
                    },
                    userInfo: {
                        ...state.userInfo,
                        phone: payload
                    }
                };
            }
            return state;
        }
      default:
        return state;
    }
}
